import React from 'react';

import { DateTime } from 'luxon';

import { useGetDashboardWorkLetterUsageQuery } from 'src/api';
import { DEFAULT_END_DATE } from 'src/constants/dashboard';
import { useDashboardCVAdminData } from 'src/hooks/dashboard';

import { MIN_DATE_WORK_LETTER_REPORT, NOW } from '../constants';
import { DashboardWorkLetterUsageBlock } from '../DashboardWorkLetterUsageBlock';

export const DashboardGlobalCVAdminWorkLetterUsageBlock: React.FC = () => {
  const {
    employers,
    peos,
    workLetterUsageEndDate,
    setWorkLetterUsageEndDate,
    workLetterUsageStartDate,
    setWorkLetterUsageStartDate,
  } = useDashboardCVAdminData();

  const startDate = React.useMemo(
    () =>
      workLetterUsageStartDate
        ? DateTime.max(workLetterUsageStartDate, MIN_DATE_WORK_LETTER_REPORT)
        : MIN_DATE_WORK_LETTER_REPORT,
    [workLetterUsageStartDate],
  );

  const { data, loading } = useGetDashboardWorkLetterUsageQuery({
    variables: {
      employerIds: employers?.length ? employers.map(employer => employer.id) : undefined,
      peoIds: peos?.length ? peos.map(peo => peo.id) : undefined,
      from: startDate.toISO() ?? '',
      to: (workLetterUsageEndDate || DEFAULT_END_DATE).toISO() ?? '',
    },
  });

  return (
    <DashboardWorkLetterUsageBlock
      dashboardWorkLetterUsageItems={data?.getDashboardWorkLetterUsage ?? []}
      minDate={MIN_DATE_WORK_LETTER_REPORT}
      maxDate={NOW}
      loading={loading}
      startDate={startDate}
      endDate={workLetterUsageEndDate}
      onStartDateChange={setWorkLetterUsageStartDate}
      onEndDateChange={setWorkLetterUsageEndDate}
    />
  );
};
